import PropTypes from 'prop-types';
import React from 'react';

const SearchAnalyticsContext = React.createContext({});

SearchAnalyticsContext.displayName = 'SearchAnalyticsContext';

SearchAnalyticsContext.Provider.propTypes = {
  value: PropTypes.shape({
    trackAddToListClick: PropTypes.func.isRequired,
    trackAddToNewListClick: PropTypes.func.isRequired,
    trackBibAuthorClick: PropTypes.func.isRequired,
    trackBibJacketClick: PropTypes.func.isRequired,
    trackBibTitleClick: PropTypes.func.isRequired,
    trackCardExploreClick: PropTypes.func.isRequired,
    trackCardImageClick: PropTypes.func.isRequired,
    trackCardImpression: PropTypes.func.isRequired,
    trackCardTitleClick: PropTypes.func.isRequired,
    trackCardEventInterestedClick: PropTypes.func.isRequired,
    trackRecommendationClick: PropTypes.func.isRequired,
    trackViewAvailabilityClick: PropTypes.func.isRequired,
    trackViewDigitalResourceClick: PropTypes.func.isRequired,
    trackViewManifestationClick: PropTypes.func.isRequired
  }).isRequired
};

export default SearchAnalyticsContext;
